(function () {
  var tiers = [
    { c: 2, p: '10%' },
    { c: 3, p: '15%' },
    { c: 4, p: '20%' },
    { c: 5, p: '25%' }
  ];

  var last = -1;

  function getRoot() {
    return document.getElementById('rw-root');
  }

  function update(n) {
    n = parseInt(n, 10) || 0;

    // If same count, skip rerender
    if (n === last) return;
    last = n;

    var root = getRoot();
    if (!root) return;

    var copy = document.getElementById('rw-copy');
    if (!copy) return;

    var active = null;
    var next = null;

    for (var i = 0; i < tiers.length; i++) {
      if (n >= tiers[i].c) active = tiers[i];
      if (!next && n < tiers[i].c) next = tiers[i];
    }

    var s = document.getElementById('s0');
    if (s) s.className = 'rw-start' + (n >= 1 ? ' on' : '');

    [1, 2, 3, 4].forEach(function (k, i) {
      var reached = n >= tiers[i].c;
      var isNext = next && next.c === tiers[i].c;

      var d = document.getElementById('d' + k);
      var l = document.getElementById('lq' + k);
      var f = document.getElementById('f' + k);

      if (d) d.className = 'rw-dot' + (reached ? ' done' : isNext ? ' next' : '');
      if (l) l.className = 'rw-lbl-qty' + (reached ? ' done' : isNext ? ' next' : '');
      if (f) f.style.width = reached ? '100%' : '0%';
    });

    if (!active) {
      var need = Math.max(0, 2 - n);
      copy.innerHTML =
        'Add <strong>' + need + ' more item' + (need !== 1 ? 's' : '') +
        '</strong> to unlock <span class="hl">10% EXTRA OFF</span>';
    } else if (!next) {
      copy.innerHTML =
        '<strong>MAX SAVINGS UNLOCKED</strong> — You\'re getting <span class="hl">25% EXTRA OFF</span>';
    } else {
      var needed = next.c - n;
      copy.innerHTML =
        'Add <strong>' + needed + ' more item' + (needed !== 1 ? 's' : '') +
        '</strong> to get <span class="hl">' + next.p + ' EXTRA OFF</span>';
    }
  }

  function refreshRewardBar() {
    fetch('/cart.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        update(cart.item_count || 0);
      })
      .catch(function () {});
  }

  function queueRefresh() {
    setTimeout(refreshRewardBar, 150);
    setTimeout(refreshRewardBar, 400);
    setTimeout(refreshRewardBar, 800);
    setTimeout(refreshRewardBar, 1200);
  }

  // Add to cart / submit buttons
  document.addEventListener('click', function (e) {
    if (e.target.closest('[name="add"], .product-form__submit, button[type="submit"]')) {
      queueRefresh();
    }
  });

  // Quantity/remove buttons
  document.addEventListener('click', function (e) {
    if (
      e.target.closest('[href*="/cart/change"]') ||
      e.target.closest('[data-line]') ||
      e.target.closest('[name="minus"]') ||
      e.target.closest('[name="plus"]') ||
      e.target.closest('[name="remove"]') ||
      e.target.closest('[data-action="remove"]') ||
      e.target.closest('[data-action="decrease-quantity"]') ||
      e.target.closest('[data-action="increase-quantity"]') ||
      e.target.closest('.cart-remove-button') ||
      e.target.closest('.quantity-selector__button')
    ) {
      queueRefresh();
    }
  });

  // Form submissions
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form) return;

    if (
      form.matches('form[action*="/cart/add"]') ||
      form.matches('form[action*="/cart/change"]') ||
      form.matches('form[action*="/cart/update"]')
    ) {
      queueRefresh();
    }
  });

  // Custom theme/app events
  document.addEventListener('cart:refresh', queueRefresh);
  document.addEventListener('cart:updated', queueRefresh);
  document.addEventListener('ajaxProduct:added', queueRefresh);
  document.addEventListener('ajaxProduct:updated', queueRefresh);
  document.addEventListener('variant:add', queueRefresh);

  // Wrap fetch
  var originalFetch = window.fetch;
  if (originalFetch && !window.__rwFetchWrapped) {
    window.__rwFetchWrapped = true;

    window.fetch = function () {
      var args = arguments;
      return originalFetch.apply(this, args).then(function (response) {
        try {
          var url = args[0];
          if (
            typeof url === 'string' &&
            (
              url.indexOf('/cart/add') !== -1 ||
              url.indexOf('/cart/change') !== -1 ||
              url.indexOf('/cart/update') !== -1 ||
              url.indexOf('/cart/clear') !== -1
            )
          ) {
            queueRefresh();
          }
        } catch (e) {}
        return response;
      });
    };
  }

  // Wrap XHR
  if (!window.__rwXhrWrapped) {
    window.__rwXhrWrapped = true;

    var originalOpen = XMLHttpRequest.prototype.open;
    var originalSend = XMLHttpRequest.prototype.send;

    XMLHttpRequest.prototype.open = function (method, url) {
      this._rwUrl = url;
      return originalOpen.apply(this, arguments);
    };

    XMLHttpRequest.prototype.send = function () {
      this.addEventListener('load', function () {
        try {
          var url = this._rwUrl || '';
          if (
            typeof url === 'string' &&
            (
              url.indexOf('/cart/add') !== -1 ||
              url.indexOf('/cart/change') !== -1 ||
              url.indexOf('/cart/update') !== -1 ||
              url.indexOf('/cart/clear') !== -1
            )
          ) {
            queueRefresh();
          }
        } catch (e) {}
      });

      return originalSend.apply(this, arguments);
    };
  }

  // Observe cart drawer changes
  var observer = new MutationObserver(function () {
    queueRefresh();
  });

  var cartDrawer = document.querySelector('cart-drawer, .cart-drawer, .drawer, #cart-drawer, .mini-cart');
  if (cartDrawer) {
    observer.observe(cartDrawer, {
      childList: true,
      subtree: true
    });
  }

  refreshRewardBar();
})();